import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants"

export const DEIPageTeamsSectionSECTION = styled.section`
  padding: 100px 0;

  h2 {
    text-align: center;
    margin: 0 0 40px;
  }

  .Tabs--Items {
    margin-bottom: 30px;
  }

  .Tabs--Option {
    margin: 0;

    ${MEDIA_QUERIES.L} {
      padding: 0 18px;
    }
  }
`;
